import { useEffect, useState } from 'react';
import Loadable from '@app/utils/Loadable';

// While a loadable reloads, its last resolved result stands in for it, so a table keeps its rows and total
export default function useLastResolved<T>(loadable: Loadable<T>): T | undefined {
  const [lastResolved, setLastResolved] = useState<T>();

  useEffect(() => {
    if (loadable.isResolved()) {
      setLastResolved(loadable.result);
    }
  }, [loadable]);

  return loadable.isResolved() ? loadable.result : lastResolved;
}
